import { gql } from '@/utilities/gql';
import { NARRATIVE_CARD_COMPACT_SYNTHETIC_OPTION_FRAGMENT } from '../narrativeOptionFragment';
import { makeGqlSuspenseQuery } from '@/utilities/gqlQuery';

const QUERY = gql(
  `
  query GetNarrativeValuationOptions($canonicalUrl: String!) {
    Company(canonicalURL: $canonicalUrl) {
      valuationOptions {
        ...NarrativeCardCompactSyntheticOptionFields
      }
    }
  }
`,
  [NARRATIVE_CARD_COMPACT_SYNTHETIC_OPTION_FRAGMENT]
);

export const useNarrativeSyntheticValuationOptions = makeGqlSuspenseQuery(
  QUERY,
  {
    tags: ['narrative', 'narrative-synthetic-valuation-options'],
  }
);
